<template>
  <div class="pushStream-container">
    <div class="pushStream-content" v-if="plugFlowList.length != 0">
      <div class="pushStream-content-left">
        <h4>{{$t('pushstream.播放列表')}}</h4>
        <p class="fontsize12">{{$t('pushstream.推流数量')}} ≤ {{maxChannel}}</p>
      </div>
      <div>
        <el-button
          size="small"
          type="primary"
          @click="allPlugFlowFun"
          :disabled="avctl == 0 || isAllPush"
          >{{$t('pushstream.一键推流')}}</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="addFlow"
          :disabled="plugFlowList.length >= maxChannel || avctl == 0"
          >{{$t('pushstream.添加推流地址')}}</el-button
        >       
      </div>
    </div>
    <div v-else class="pushStream-add" :class="{'push-disabled': avctl == 0}">
      <el-button type="primary" @click="addFlow" :disabled="avctl == 0"
        >{{$t('pushstream.添加推流地址')}}</el-button
      >
      <p v-if="avctl == 0" class="disabled-pushStream">{{$t('pushstream.主控权限才可操作')}}</p>
    </div>
    <ul class="pushStream-body scrollbar">
      <li
        class="pushStream-content"
        v-for="item in plugFlowList"
        :key="item.id"
      >
        <div class="pushStream-content-left">
          <h4>{{ item.platform }}</h4>
          <p class="fontsize12">{{ dpiObject[item.resolution] }}</p>
        </div>
        <div>
          <span style="margin-right: 10px"  v-if="`${item.state}` === `0`">{{$t('pushstream.推流中')}}</span>
          <el-button
            v-if="`${item.state}` === `0`"
            size="small"
            type="primary"
             :disabled="avctl == 0"
            @click="stopPushstream(item.id)"
            >{{$t('pushstream.结束推流')}}</el-button
          >
          <span
            v-if="item.isErr"
            style="margin-right: 10px; color: #ff5d47"
            >{{$t('pushstream.推流失败')}}</span
          >
          <el-button
            v-if="`${item.state}` === `1` || `${item.state}` === `3`"
            size="small"
            type="primary"
            :disabled="avctl == 0"
            @click="startPushstreamFunc(item)"
            >{{$t('pushstream.开始推流')}}</el-button
          >
          <el-button
            size="small"
            :disabled="`${item.state}` !== `1` || avctl == 0"
            type="primary"
            @click="editPushstream(item)"
            >{{$t('pushstream.编辑')}}</el-button
          >
          <el-button
            :disabled="`${item.state}` !== `1` || avctl == 0"
            size="small"
            type="danger"
            @click="deletPushstreamFunc(item.id)"
            >{{$t('pushstream.删除')}}</el-button
          >
        </div>
      </li>
    </ul>
    <el-dialog
      class="dialog-dark"
      :title="$t('pushstream.添加推流地址')"
      append-to-body
      :before-close="addPlugFlowClose"
      :visible.sync="addPlugFlowVisble"
      :close-on-click-modal="false"
      width="420px"
    >
      <div class="form-dark">
        <el-form
          ref="addPlugFlow"
          :rules="rules"
          size="small"
          label-width="6rem"
          :model="addPlugFlowObj"
        >
          <el-form-item
            :label="$t('pushstream.平台名称')"
            prop="platform"
            class="addPlugFlowItem"
          >
            <el-input
              v-model.trim="addPlugFlowObj.platform"
              :placeholder = "$t('pushstream.请输入平台名称')"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('pushstream.推流地址')"
            prop="pushStreamUrl"
            class="addPlugFlowItem"
          >
            <el-input
              v-model.trim="addPlugFlowObj.pushStreamUrl"
              maxlength="32767"
              :placeholder = "$t('pushstream.请输入推流地址')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('pushstream.分辨率')" class="addPlugFlowItem">
            <el-select
              v-model="addPlugFlowObj.resolution"
              :placeholder = "$t('pushstream.请选择')"
              style="width: 100%"
              popper-class="tip-select"
            >
              <el-option
                :label="$t('pushstream.超高清')"
                value="UD"
                v-if="liveResolution == 1080"
              ></el-option>
              <el-option
                :label="$t('pushstream.高清')"
                value="HD"
              ></el-option>
              <el-option
                :label="$t('pushstream.标清')"
                value="LD"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialogButtton">
        <el-button
          :disabled="!addPlugFlowObj.platform || !addPlugFlowObj.pushStreamUrl || clickFlag"
          class="button-mini" 
          type="primary" 
          size="mini" 
          @click="submitPlugFlow"
          >{{$t('pushstream.确定')}}</el-button
        >
        <el-button class="button-mini" @click="addPlugFlowClose" size="mini">{{$t('pushstream.取消')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addPushstream,
  getPushstreamList,
  startPushstream,
  deletPushstream,
  stopPushstream,
  startAllPushstream,
  editPushstream,
} from "@/api/liveRequest/plugFlowApi";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
export default {
  name: "pushstream",
  computed: {
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    recordStatus() {
      return this.$store.getters.recordStatus;
    },
    avctl() {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.avctl
      );
    },
    isAllPush(){
       return this.plugFlowList.find((info)=>{return info.state != 0}) ? false : true
    },
    liveResolution(){
       return sessionStorage.getItem("live_resolution")
    },
    maxChannel() {
      return sessionStorage.getItem("retweet_max_channel")
    },
    
    rules() {
      return {
        platform: [
          {
            required: true,
            message: this.$t("pushstream.请输入平台名称平台"),
            trigger: "blur",
          },
        ],
         pushStreamUrl: [
          {
            required: true,
            message: this.$t("pushstream.请输入推流地址推"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  data() {
    return {
      boxShow: false,
      addPlugFlowVisble: false,
      // allPlugFlowVisible: false,
      addPlugFlowObj: {
        platform: "",
        pushStreamUrl: "",
        resolution: "HD",
      },
      plugFlowList: [],
      // rules: {
      //   platform: [
      //     {
      //       required: true,
      //       message: this.$t("pushstream.请输入平台名称平台"),
      //       trigger: "blur",
      //     },
      //   ],
      //   pushStreamUrl: [
      //     {
      //       required: true,
      //       message: this.$t("pushstream.请输入推流地址推"),
      //       trigger: "blur",
      //     },
      //   ],
      // },
      dpiObject: {
        LD: "640*360",
        HD: "1280*720",
        UD: "1920*1080",
      },
      loadingState: false,
      stopPushFlowVisible: false,
      stopId: "",
      editFlag: false,
      clickFlag: false,
    };
  },
  mounted() {
    this.getPushstreamListFunc();
    pushRoomMessageFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
  },
  methods: {
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7127: {
          this.disposeCustomMessage_7127(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7127(requestData) {
      if (requestData.event === "custom_stream_change") {
        this.getPushstreamListFunc();
      } else if (requestData.event == "monitor_customer_pushStreamStatus") {
        this.getPushstreamListFunc();
        let { status, id } = JSON.parse(requestData.message);
        let item = this.plugFlowList.find((val) => val.id == id);
        item.isErr = true
        if (status == "finish") {
          this.$message.error(this.$t('pushstream.推流失败，请检查推流设置'))
          // this.$message(
          //   `${item.platform}推流失败，请检查推流设置`,
          //   "提示信息",
          //   {
          //     confirmButtonText: "确定",
          //   }
          // );
        }
      }
    },
    /* 结束推流确认弹窗 */
    stopPushstream(id) {
      this.stopId = id;
      this.stopPushFlowVisible = true;
      stopPushstream({ id: this.stopId }, this.liveToken)
        .then((res) => {
          this.loadingState = false;
          if (res.code === 200) {
            this.stopPushFlowVisible = false;
            // this.getPushstreamListFunc()
          } else {
            this.$message.error(this.$t('pushstream.结束推流失败'));
          }
        })
        .catch(() => {
          this.loadingState = false;
        });
    },
    /**停止推流 */
    stopPushstreamFunc() {
      this.loadingState = true;
      stopPushstream({ id: this.stopId }, this.liveToken)
        .then((res) => {
          this.loadingState = false;
          if (res.code === 200) {
            this.stopPushFlowVisible = false;
            // this.getPushstreamListFunc()
          } else {
            this.$message.error(this.$t('pushstream.结束推流失败'));
          }
        })
        .catch(() => {
          this.loadingState = false;
        });
    },
    /** 删除第三方推流 */
    deletPushstreamFunc(id) {
      this.loadingState = true;
      deletPushstream(id, this.liveToken)
        .then((res) => {
          console.log(res, "res_deletPushstream");
          if (res.code === 200) {
            // this.getPushstreamListFunc()
          } else {
            this.loadingState = false;
          }
        })
        .catch((err) => {
          console.log(err, "err_deletPushstream");
          this.loadingState = false;
        });
    },
    /**开始推流 */
    startPushstreamFunc(item) {
      if(item.isErr){item.isErr = true}
      if (this.liveStartStatus !== 2) {
        this.$message.warning(this.$t('pushstream.直播未开始，不能进行推流'));
        return;
      }
      startPushstream(
        {
          id: item.id,
        },
        this.liveToken
      )
        .then((res) => {
          console.log(res, "res_startPushstream");
          if (res.code === 200) {
            // this.getPushstreamListFunc()
          } else if (res.code == 6000) {
            this.$message.warning(this.$t('pushstream.当前直播间并发已满，不允许再推流'));
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err, "err_startPushstream");
        });
    },
    isExitErr(){
      this.plugFlowList.forEach((i)=>{
         if(i.isErr){
           i.isErr = false
         }
      })
    },
    addFlow() {
      this.addPlugFlowObj = {
        platform: "",
        pushStreamUrl: "",
        resolution: "HD",
      };
      // this.addPlugFlowObj.resolution =
      //   this.maxResolution.max_resolution >= 720 ? "HD" : "LD";
      this.addPlugFlowVisble = true;
      this.clickFlag = false;
    },
    /* 编辑推流 */
    editPushstream(item) {
      this.addPlugFlowVisble = true;
      this.clickFlag = false;
      this.addPlugFlowObj = { ...item };
    },
    // 一键推流
    allPlugFlowFun() {
      if (this.liveStartStatus !== 2) {
        this.$message.warning(this.$t('pushstream.直播未开始，不能进行推流'));
        return;
      }
      this.isExitErr()
      this.allPlugFlowFunc();
    },
    getPushstreamListFunc() {
      this.loadingState = true;
      getPushstreamList(
        {
          webcastId: this.liveId,
        },
        this.liveToken
      )
        .then((res) => {
          if (res.code === 200) {
            this.plugFlowList =JSON.parse(JSON.stringify(res.data.map((a)=>{return Object.assign(a,{isErr:false})})));
            let flag = this.plugFlowList.some((val) => val.state == 0);
            console.log(flag, "推流状态888888888888");
            this.$store.commit("SET_FLOWSTATUS", flag);
          } else {
            this.$message.error(res.msg);
          }
          this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, "err_getPushstreamList");
          this.loadingState = false;
        });
    },
    submitPlugFlow() {
      this.clickFlag = true;
      let reg = /^(rtmp|RTMP):\/\/.*/;
      const pattern = new RegExp(
        "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"
      );
      if (pattern.test(this.addPlugFlowObj.platform)) {
        this.$message.warning(this.$t('pushstream.平台名称不可包含特殊字符'));
        return;
      }
      if (!reg.test(this.addPlugFlowObj.pushStreamUrl)) {
        this.$message.warning(this.$t('pushstream.推流地址必须以'));
        return;
      }
      this.$refs.addPlugFlow.validate((valid) => {
        if (valid) {
          console.log(this.clickFlag,'是否正在提交')
          if (this.addPlugFlowObj.id) {
            this.editPushstreamFunc();
            return;
          }
          this.addPushstreamFunc();
        }
      });
    },
    async editPushstreamFunc() {
      let { platform, resolution, id } = this.addPlugFlowObj;
      let { code } = await editPushstream(
        {
          platform,
          resolution,
          id,
          push_stream_url: this.addPlugFlowObj.pushStreamUrl,
        },
        this.liveToken
      );
      if (code == 200) {
        this.$message.success(this.$t('pushstream.编辑成功'));
        this.addPlugFlowVisble = false;     
        this.$refs.addPlugFlow.resetFields()
        this.getPushstreamListFunc();
      } else if (code === 1020) {
        this.$message.error(this.$t('pushstream.编辑失败推流地址重复'));
      }
      setTimeout(function() {
        this.clickFlag = false;
      }, 100);
    },
    addPushstreamFunc() {
      addPushstream(
        {
          webcastId: this.liveId,
          ...this.addPlugFlowObj,
        },
        this.liveToken
      )
        .then((res) => {
          
          if (res.code === 200) {
            this.addPlugFlowVisble = false;
          } else if (res.code === 1020) {
            this.$message.error(this.$t('pushstream.添加失败推流地址重复'));
          } else {
            this.$message.error(`${res.msg}`);
            this.addPlugFlowVisble = false;
            this.$refs.addPlugFlow.resetFields()
          }
          setTimeout(function() {
            this.clickFlag = false;
            console.log("提交成功", this.clickFlag);
          }, 100);
        })
        .catch((err) => {
          console.log(err, "err_addPushstream");

          this.addPlugFlowVisble = false;
          this.$refs.addPlugFlow.resetFields()
          setTimeout(function() {
            this.clickFlag = false;
          }, 100);
        });
    },
    allPlugFlowFunc() {
      startAllPushstream(this.liveToken)
        .then((res) => {
          if (res.code !== 200) {
            if(res.code == 1025){
               this.$message.error(this.$t('pushstream.服务已停用'));
            }else{
            this.$message.error(res.msg);
            }
          }
        })
        .catch(() => {
          this.$message.error(this.$t('pushstream.失败'));
        });
    },
    addPlugFlowClose() {
      this.addPlugFlowVisble = false;
      this.$refs.addPlugFlow.resetFields()
    },
  },
};
</script>

<style  lang="scss" scoped>
.pushStream-container {
  background-color: #2d304f;
  height: 432px;
  .pushStream-add {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .el-button {
      background-color: transparent;
      color: #3986EE;
      border-radius: 6px;
    }
    .disabled-pushStream{
      text-align: center;
      margin-top:16px;
    }
  }
  .push-disabled{
    .el-button{
      opacity: 0.5;
    }
  }
  .pushStream-body {
    overflow-y: scroll;
    height: 360px;
  }
  .pushStream-content-left {
    display: flex;
    align-items: center;
    h4 {
      margin-right: 10px;
    }
  }
  .pushStream-content {
    display: flex;
    justify-content: space-between;
    height: 70px;
    align-items: center;
    margin: 0px 30px;
    border-bottom: 1px solid #797e92;
  }
  .addPlugFlowItem {
    margin-bottom: 20px;
  }
}
</style>
